import React from "react";

const EditMailThread = () => {
  return <div>No Edit Options</div>;
};

export default EditMailThread;
